var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container container-with-transition student-container"},[_c('transition',{attrs:{"name":_vm.componentTransition}},[_c(_vm.currentPage,{tag:"component",staticClass:"student-page"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }